import { HelpCircleIcon } from "@hugeicons-pro/core-solid-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";
import { useUnitsPropertiesDictionary } from "shared/hooks/use-units-properties";
import { Applicant } from "types/application";
import { EmptyCellIcon } from "./TableBodySections/components/EmptyCellIcon";

export const AuditSummaryFlag = ({
  audit_summary_flags
}: {
  audit_summary_flags?: Applicant["audit_summary_flags"];
}) => {
  const { unit } = useUnitsPropertiesDictionary();

  if (!audit_summary_flags) return null;

  return (
    <div className="flex gap-2 items-center">
      <Tooltip>
        <TooltipTrigger as="div" className="cursor-pointer text-left">
          <HugeiconsIcon
            icon={HelpCircleIcon}
            className="text-danger-500"
            size={20}
          />
        </TooltipTrigger>

        <TooltipContent className="max-w-[480px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-content-1000-inverted shadow-xs">
          <Show if={audit_summary_flags.application_id_changed}>
            No data available. Application was transferred from a group for
            which this data was not requested
          </Show>

          <Show if={audit_summary_flags.unit_id_changed}>
            No data available. Application was moved from a {unit} where this
            data was not requested
          </Show>

          <Show if={audit_summary_flags.role_changed}>
            No data available. Role has been changed after submission
          </Show>
        </TooltipContent>
      </Tooltip>

      <EmptyCellIcon />
    </div>
  );
};
